export default function KBSearchController(KBSearchConfig, CatalogService, DatabaseService) {
    var ctrl = this;

    ctrl.maxSize = KBSearchConfig.maxSize;
    ctrl.hitsList = KBSearchConfig.hitsList;
    ctrl.modesList = KBSearchConfig.modesList;
    ctrl.relationsList = KBSearchConfig.relationsList;
    ctrl.locationsList = KBSearchConfig.locationsList;
    ctrl.languagesList = KBSearchConfig.languagesList;
    ctrl.query = {};
    ctrl.catalog_options = [];
    ctrl.catalog_select = {};

    ctrl.$onChanges = function(changes) {
        if (changes) {
            if (changes.rsnList) {
                ctrl.rsnList = changes.rsnList.currentValue;
            }
            if (changes.facetsList) {
                ctrl.facetsList = changes.facetsList.currentValue;
            }
            if (changes.attributesList) {
                ctrl.attributesList = changes.attributesList.currentValue;
            }
            if (changes.materialsList) {
                ctrl.materialsList = changes.materialsList.currentValue;
            }
            if (changes.sortKeysList) {
                ctrl.sortKeysList = changes.sortKeysList.currentValue;
            }
            if (changes.schemasList) {
                ctrl.schemasList = changes.schemasList.currentValue;
            }
        }
    };

    ctrl.$onInit = function() {
        if (!ctrl.rsnList) {
            ctrl.rsnList = KBSearchConfig.rsnList;
        }
        if (!ctrl.facetsList) {
            ctrl.facetsList = KBSearchConfig.facetsList;
        }
        if (!ctrl.attributesList) {
            ctrl.attributesList = KBSearchConfig.attributesList;
        }
        if (!ctrl.materialsList) {
            ctrl.materialsList = KBSearchConfig.materialsList;
        }
        if (!ctrl.sortKeysList) {
            ctrl.sortKeysList = KBSearchConfig.sortKeysList;
        }
        if (!ctrl.schemasList) {
            ctrl.schemasList = KBSearchConfig.schemasList;
        }
        ctrl.callReset();
    }

    ctrl.getCatalogOptions = function() {
        CatalogService.get({}).$promise.then(function(response) {
            if (response.success) {
                ctrl.catalog_options = [];
                for(var i=0; i<response.data.length; i++) {
                    if (response.data[i].enable) {
                        ctrl.catalog_options.push({
                            value: response.data[i].uuid,
                            label: response.data[i].name,
                        });
                    }
                    if (response.data.length > 0 && i == response.data.length-1) {
                        ctrl.catalog_select = ctrl.catalog_options[0];
                    }
                }
            }
        });
    };

    ctrl.getTerms = function(val) {
        var params = {};
        params.id = ctrl.catalog_select.value;
        params.command = 'scan';
        params.type = 'CQL';
        params.scanClause = 'cuba.serverChoice="' + val  + '"';
        //params.scanClause = '@1=1016 @6=3 "' + val  + '"';
        params.responePosition = 1;
        return CatalogService.get(params).$promise.then(function(response) {
            return response.data.terms.map(function(item){
                return item.displayTerm.replace(/(^\s+|\s+$)/g, '');
            });
        });
    };

    ctrl.callReset = function() {
        /*
         * For all forms
         */

        ctrl.getCatalogOptions();

        ctrl.query.cql = null;
        ctrl.query.refine = null;
        ctrl.query.current = 1;
        ctrl.query.hits = ctrl.hitsList[2];
        ctrl.query.schema = ctrl.schemasList[0];
        ctrl.query.sortby = ctrl.sortKeysList[0];
        ctrl.response = undefined;
        ctrl.error = undefined;
        ctrl.selectedFacet = undefined;
        ctrl.selectedFacetItem = undefined;
        /* 
         * For a form with free text
         */
        ctrl.query.freetext = null;
        /*
         * For a form with attributes
         */
        ctrl.query.term1 = null;
        ctrl.query.term2 = null;
        ctrl.query.term3 = null;
        ctrl.query.attr1 = ctrl.attributesList[0];
        ctrl.query.attr2 = ctrl.attributesList[1];
        ctrl.query.attr3 = ctrl.attributesList[2];
        ctrl.query.rel1 = ctrl.relationsList[0];
        ctrl.query.rel2 = ctrl.relationsList[0];
        ctrl.query.rel3 = ctrl.relationsList[0];
        ctrl.query.loc = ctrl.locationsList[0];
        ctrl.query.material = ctrl.materialsList[0];
        ctrl.query.lang = ctrl.languagesList[0];
        ctrl.query.start = ctrl.query.end = null;
    };

    ctrl.callSearch = function() {
        ctrl.loading = true;
        search(ctrl.catalog_select.value, ctrl.query, function(err, response) {
            ctrl.loading = false;
            if (err) {
                ctrl.error = err.message || err;
            }
            ctrl.response = response.data;
        });
    };


    ctrl.pageChanged = function() {
        ctrl.callSearch();
    };

    ctrl.firstPage = function() {
        ctrl.query.current = 1;
        ctrl.callSearch();
    };

    ctrl.callRefineSearch = function(item) {
        var apt = item.facetspec.index + '=' + '"' + item.DATA + '"'; 
        if (ctrl.query.refine) {
            //ctrl.query.refine = '@and ' + ctrl.query.refine + ' ' + apt;
            ctrl.query.refine = ctrl.query.refine + ' and ' + apt;
        } else {
            ctrl.query.refine = apt;
        }
        ctrl.query.current = 1;
        ctrl.callSearch();
    };

    ctrl.callNext = function() {
        if (ctrl.onNext) ctrl.onNext();
    };

    ////////

    function search(id, q, done) {
        var params = {};
        params.id = id;
        params.command = 'search';
        params.startRecord = (q.current-1)*q.hits.value+1
        params.maximumRecords = q.hits.value;
        params.recordSchema = q.schema.value;
        params.sortKeys = q.sortby.value;

        params.query = '';
        params.type = 'CQL';
       
        if (q.term1 || q.term2 || q.term3) {
            var apt = [];
            var i;
            var n;


            for(i = 0; i<3; i++) {
                n = i + 1;
                apt[i] = {
                    attr: q['attr'+n].value,
                    rel: q['rel'+n].value,
                    term: q['term'+n]
                };
            }
            for(i in apt) {
                if (apt[i].term) {
                    if (params.query) {
                        params.query += ' and ';
                    }
                    params.query += '(' + apt[i].attr + ' ' + apt[i].rel + ' '+ '"' + apt[i].term + '")';
                }
            }
            // limits
            /*
            if (q.loc.value) {
                params.query += ' and ' + 'cuba.999b="' +  q.loc.value + '"';
            }
            if (q.lang.value) {
                params.query += ' and ' + 'dc.language="' + q.lang.value + '"';
            }
            if (q.material.value) {
                params.query += ' and ' + q.material.value;
            }
            if (q.start) { 
                params.query += ' and (dc.date >= ' + q.start + ')';
            }
            if (q.end) {
                params.query += ' and (dc.date <= ' + q.end + ')';
            }
            */
        } else if (q.freetext && q.freetext.lastIndexOf('cql:') === 0) {
            params.query = q.freetext.substr(4);
        } else {
            //params.query = 'cuba.serverChoice =/relevant "' + q.freetext.replace(/"/g, '\\"') + '"';
            params.query = 'cql.serverChoice any/relevant "' + q.freetext.replace(/"/g, '\\"') + '"';
        }

        if (q.refine) {
            params.query = params.query + ' and (' + q.refine + ')';
        }

        if (q.sortby.value) {
            params.query = params.query + ' or ' + q.sortby.value;
        }

        CatalogService.get(params).$promise.then(function(response) {

            ctrl.query.cql = params.query; // FIXME!

            done(null, response);
        }, function(err) {
            done(err, null);
        });
    }

}
KBSearchController.$inject = ['KBSearchConfig', 'CatalogService', 'DatabaseService'];
